<template>
  <div class="footer">
    <div class="footer-separator"/>
    <div class="sblock">
      <div class="icon-container" @click="openSocial('https://www.facebook.com/signeokkels')">
        <fb-icon class="icon"/>
      </div>
      <div class="icon-container" @click="openSocial('https://twitter.com/SigneOkkels')">
        <tw-icon class="icon"/>
      </div>
      <div class="icon-container" @click="openSocial('https://www.instagram.com/signeokkelslarsen/?hl=en')">
        <insta-icon class="icon"/>
      </div>
      <div class="icon-container" @click="openSocial('https://www.linkedin.com/in/signeokkelslarsen/')">
        <linkedin-icon class="icon"/>
      </div>
    </div>
    <div class="copyright">&#169; Signe Okkels Larsen</div>
  </div>
</template>

<script>
import { FacebookIcon } from 'vue-feather-icons'
import { TwitterIcon } from 'vue-feather-icons'
import { InstagramIcon } from 'vue-feather-icons'
import { LinkedinIcon } from 'vue-feather-icons'


export default {
  name: "Footer",
  components: {
    'fb-icon': FacebookIcon,
    'tw-icon': TwitterIcon,
    'insta-icon': InstagramIcon,
    'linkedin-icon': LinkedinIcon
  },
  methods:{
      openSocial: function (url) {
          window.open(url, "_blank");
      }
    }
}
</script>

<style lang="scss" scoped>
@import "src/theme.scss";

.footer-separator {
  width: 60vw;
  height: 1px;
  background-color: $grey-300;
  margin: 48px auto 0 auto;
}
.sblock {
  margin: 48px auto 0 auto;
}
.copyright {
  margin: 32px auto 48px auto;
}
.icon-container {
  display: inline-block;
  border-radius: 4px;
  width: 38px;
  height: 38px;
  background-color: $grey-300;
  margin-right: 16px;
}
.icon-container:hover {
  background-color: $grey-200;
  cursor: pointer;
}
.icon {
  margin-top: 6px;
  color: $white-color;
}

</style>